









































import { ClientPolicyDto, PolicyIndividualDTO } from '@core/pages/new-business-register/api'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import EmployeeBenefitPolicySection from '../EmployeeBenefitPolicySection.vue'
import EmployeeBenefitPolicyDetailSection from '../EmployeeBenefitPolicyDetailSection.vue'
import RiderSection from '../RiderSection.vue'
import RiderDetailSection from '../RiderDetailSection.vue'
import ViewPolicyPlaceHolderSection from '../ViewPolicyPlaceHolderSection.vue'
import { ClientPolicy } from '@core/pages/new-business-register/components/policy/model/ClientPolicyDTO'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import AddManualNbrDTO from '../../policy-list/AddManualNbrDTO'
import { generalProductTypes, isInclude, riderProductTypes } from '@master/model/common/ProductMeta'
import { ProductList } from '@core/pages/adminProductList/model/ProductList'
import { CompanyDetailsMetaList } from '@core/pages/companyDetails/model/CompanyDetailsMetaList'

const clientPolicyStore = namespace('ClientPolicyStore')
const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    EmployeeBenefitPolicySection,
    EmployeeBenefitPolicyDetailSection,
    RiderSection,
    RiderDetailSection,
    ViewPolicyPlaceHolderSection
  }
})
export default class RiderPage extends Vue {
  @clientPolicyStore.State
  private policy: ClientPolicyDto

  @clientPolicyStore.State
  private policyInView: ClientPolicyDto

  @clientPolicyStore.State
  private policyIndividuals: PolicyIndividualDTO[]

  @clientPolicyStore.State
  private nbrStatusOptions

  @kycFormStore.State
  private productList: ProductList

  // please refer to https://wenconsulting.atlassian.net/jira/software/c/projects/IFAM/issues/IFAM-1336
  // to get the function code
  @kycFormStore.Action
  private fetchAllActiveInactiveProducts

  @clientPolicyStore.Action
  private retrieveSubPolicies

  @clientPolicyStore.State
  private subPolicies: ClientPolicyDto[]

  @clientPolicyStore.Action
  private removeSubPolicy

  @clientPolicyStore.Action
  private addNewSubPolicy

  @clientPolicyStore.Action
  private selectedPolicyInView

  @clientPolicyStore.Action
  private saveSubPolicy

  @kycFormStore.State
  private cdMetaList: CompanyDetailsMetaList

  @kycFormStore.Action
  private fetchCompanyDetails!: () => void

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  async insertNewPolicy () {
    const isConfirm = await this.uiService.confirm.show({
      type: 'warning',
      message: 'Create a new rider?'
    }) as boolean

    if (isConfirm) {
      const policyToAdd = new AddManualNbrDTO()
      policyToAdd.adviserOid = this.policy.adviserOid
      policyToAdd.mainNbrOid = this.policy.oid
      policyToAdd.clientOid = this.policy.clientOid
      policyToAdd.applicationDate = Date.now()
      // we will change it once the user has chosen the product and we update there
      policyToAdd.lineOfBusiness = ['employeebenefits', 'group-eb', 'group-eb-tailored'].includes(this.policy.type) ? 'general' : 'Insurance-Rider'
      const result = await this.addNewSubPolicy(policyToAdd)

      if (result) {
        await this.retrieveSubPolicies(this.policy.oid)
        this.uiService.alert.show({
          type: 'success',
          message: 'Successfully created rider.'
        })
      }
    }
  }

  async viewPolicyDetails (policy: ClientPolicy) {
    this.selectedPolicyInView(policy)
  }

  async removePolicy (oid: string) {
    const deleted = await this.removeSubPolicy(oid)

    if (deleted) {
      this.uiService.alert.show({
        type: 'success',
        message: `Deleted ${deleted.name}.`
      })
    }
  }

  async updateSubPolicy (policyToUpdate: ClientPolicyDto) {
    const result = await this.saveSubPolicy(policyToUpdate)
    if (result) {
      this.uiService.alert.show({
        type: 'success',
        message: `Updated ${this.policyInView.name}.`
      })
    }
  }

  get ebSubPolicies () {
    return this.subPolicies.filter(policy => isInclude(generalProductTypes, policy?.productTypeDetailed || '') || isInclude(generalProductTypes, policy?.type || ''))
  }

  get riderSubPolicies () {
    return this.subPolicies.filter(policy => isInclude(riderProductTypes, policy?.productTypeDetailed || '') || isInclude(riderProductTypes, policy?.type || ''))
  }

  get isEmployeeBenefit () {
    return ['employeebenefits', 'group-eb', 'group-eb-tailored'].includes(this.policy.type)
  }

  /**
   * For now, we just set to as the main policy's issuer option
   */
  get issuerOptions () {
    const companyFound = this.cdMetaList.getFullList().find(company => company.oid === this.policy.principal || company.companyShortName === this.policy.principal || company.companyDetailsName === this.policy.principal)

    return companyFound ? [{
      label: companyFound.companyDetailsName,
      value: companyFound.oid
    }] : []
  }

  get mainPolicyProduct () {
    return this.productList.originalList.find(product => product.oid === this.policy.productOid)
  }

  get ebOptions () {
    return this.productList.retrieveEbProductList(this.mainPolicyProduct?.productFamilyCode, this.mainPolicyProduct?.oid, this.mainPolicyProduct?.issuer_oid).map(product => {
      return {
        label: product.name,
        value: product.oid
      }
    })
  }

  get riderOptions () {
    return this.productList.retrieveRidersUsingFamilyCode(this.mainPolicyProduct?.productFamilyCode, this.mainPolicyProduct?.issuer_oid, []).map(rider => {
      return {
        label: rider.name,
        value: rider.oid
      }
    })
  }

  async mounted () {
    this.uiService = this.sharedVariable.uiService
    this.selectedPolicyInView(null)
    this.fetchCompanyDetails()
    await this.retrieveSubPolicies(this.policy.oid)
    await this.fetchAllActiveInactiveProducts()
  }
}
